// extracted by mini-css-extract-plugin
export default {"container":"qP-z","title":"rP-z","link":"sP-z"};